import React from 'react';
import { Link } from 'react-router-dom';

// Define Tag component if it's not imported from elsewhere
const Tag = ({ children, key }) => (
  <span key={key} className="card__tag">
    {children}
  </span>
);

const ModernCard = ({
  type,
  foundEntity,
  dateRange,
  API_BASE,
  Logo, // Default logo for products if needed
  handleSignIn, // For referent type
  denyRead // For referent type
}) => {
  // Determine image source based on type
  const getImageSource = () => {
    switch(type) {
      case 'veranstaltung':
        return ((foundEntity.Bild || {}).data || {}).attributes
          ? `${API_BASE}${foundEntity.Bild.data.attributes.url}`
          : "/pmp.png";
      case 'hersteller':
        return ((foundEntity.Logo || {}).data || {}).attributes
          ? `${API_BASE}${foundEntity.Logo.data.attributes.url}`
          : null;
      case 'produkt':
        return ((foundEntity.Produktbild || {}).data || {}).attributes
          ? `${API_BASE}${foundEntity.Produktbild.data.attributes.url}`
          : Logo || null;
      case 'versorgungspartner':
        return ((foundEntity.Logo || {}).data || {}).attributes
          ? `${API_BASE}${foundEntity.Logo.data.attributes.url}`
          : "/pmp.png";
      case 'referent':
        return ((foundEntity.Bild || {}).data || {}).attributes
          ? `${API_BASE}${foundEntity.Bild.data.attributes.url}`
          : null;
      default:
        return null;
    }
  };

  // Render content based on type
  const renderContent = () => {
    switch(type) {
      case 'veranstaltung':
        return (
          <div className="card__info-group">
            <div className="card__info">
              <span className="card__label">Ort</span>
              <span className="card__value">{foundEntity.isonlineveranstaltung ? <i>Veranstaltung findet online statt</i> : foundEntity.Stadt}</span>
            </div>
            <div className="card__info">
              <span className="card__label">Datum</span>
              <span className="card__value">{dateRange}</span>
            </div>
            <div className="card__info">
              <span className="card__label">Veranstalter</span>
              <span className="card__value">{foundEntity.Veranstaltername}</span>
            </div>
            {((foundEntity.Fortbildungspunkte || {}).length > 0) && (
              <div className="card__info">
                <span className="card__label">Fortbildungspunkte</span>
                <div className="card__tags">
                  {foundEntity.Fortbildungspunkte.map((f, i) => (
                    <Tag key={i}>
                      {f.Vergabestelle} [{f.Punkte} Punkte]
                    </Tag>
                  ))}
                </div>
              </div>
            )}
          </div>
        );

      case 'hersteller':
        return (
          <div className="card__info-group card__info-group--hersteller">
            <h2 className="card__title">{foundEntity.Herstellername}</h2>
            <div
              className="card__description"
              dangerouslySetInnerHTML={{ __html: foundEntity.Beschreibung }}
            />
            {foundEntity.Homepage && (
              <div className="card__website">
                <span className="card__label">Weitere Informationen:</span>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`https://${foundEntity.Homepage}`}
                  className="card__link"
                >
                  https://{foundEntity.Homepage}
                </a>
              </div>
            )}
          </div>
        );

      case 'produkt':
        return (
          <div className="card__info-group">
            <div className="card__info">
              <span className="card__label">Name</span>
              <span className="card__value">{foundEntity.Produktname}</span>
            </div>
            <div className="card__info">
              <span className="card__label">Kategorie</span>
              <span className="card__value">{foundEntity.Hauptkategorie}</span>
            </div>
            <div className="card__info">
              <span className="card__label">Unterkategorie</span>
              <span className="card__value">{foundEntity.Unterkategorie}</span>
            </div>
            <div className="card__info">
              <span className="card__label">Hersteller</span>
              <span className="card__value">
                <Link to={`/hersteller/${foundEntity.HerstellerId}`}>
                  {foundEntity.Hersteller}
                </Link>
              </span>
            </div>
          </div>
        );

      case 'versorgungspartner':
        return (
          <div className="card__info-group">
            <div className="card__info">
              <span className="card__label">Name</span>
              <span className="card__value">{foundEntity.Name}</span>
            </div>
            <div className="card__info">
              <span className="card__label">Kategorie</span>
              <span className="card__value">{foundEntity.Kategorie}</span>
            </div>
            <div className="card__info">
              <span className="card__label">Ort</span>
              <span className="card__value">{foundEntity.Stadt} {foundEntity.PLZ}</span>
            </div>
            {foundEntity.Aufgabengebiete && (
              <div className="card__info">
                <span className="card__label">Spezialisierung</span>
                <span className="card__value">{foundEntity.Aufgabengebiete.join(", ")}</span>
              </div>
            )}
            <div className="card__info">
              <button
                className="card__button"
                onClick={() => { window.open(`https://${foundEntity.Homepage}`, '_blank'); }}
              >
                Webseite besuchen
              </button>
            </div>
          </div>
        );

      case 'referent':
        return (
          <div className={`card__info-group ${!denyRead ? "" : "card__info-group--blurred"}`}>
            {denyRead && (
              <button className="card__login-button" onClick={handleSignIn}>
                Um Referenten einsehen zu können, melden Sie sich bitte an und schließen Sie ein Veranstalter Abo ab
              </button>
            )}
            <div className="card__header">
              {foundEntity.Titel && (
                <span className="card__referent-title">{foundEntity.Titel}</span>
              )}
              <h2 className="card__referent-name">{foundEntity.Vorname || ""} {foundEntity.Name || ""}</h2>
            </div>
            <div className="card__info">
              <span className="card__label">Ort</span>
              <span className="card__value">{foundEntity.Stadt}</span>
            </div>
            {foundEntity.Einsatzgebiet && (
              <div className="card__info">
                <span className="card__label">Einsatzradius</span>
                <span className="card__value">{foundEntity.Einsatzgebiet.substr(1)} km</span>
              </div>
            )}
            {foundEntity.Seminartyp && Array.isArray(foundEntity.Seminartyp) && (
              <div className="card__info">
                <span className="card__label">Seminartyp</span>
                <div className="card__tags">
                  {foundEntity.Seminartyp.map((theme, i) => (
                    <Tag key={i}>{theme}</Tag>
                  ))}
                </div>
              </div>
            )}
            <div className="card__info">
              <span className="card__label">Grundqualifikation</span>
              <div className="card__tags">
                {(foundEntity.Grundqualifikation || []).map((theme, i) => (
                  <Tag key={i}>{theme}</Tag>
                ))}
              </div>
            </div>
            <div className="card__info">
              <span className="card__label">Zusatzqualifikation</span>
              <div className="card__tags">
                {(foundEntity.Zusatzqualifikation || []).map((theme, i) => (
                  <Tag key={i}>{theme}</Tag>
                ))}
              </div>
            </div>
            {foundEntity.Kontakt && (
              <div className="card__referent-contact">
                <button className="card__button card__contact-button">
                  Kontakt aufnehmen
                </button>
              </div>
            )}
          </div>
        );

      default:
        return <div>Unknown card type</div>;
    }
  };

  const imageSrc = getImageSource();

  return (
    <div className={`card card--${type}`}>
      <div className="card__container">
        {imageSrc && type === 'referent' ? (
          <div className={`card__image-container card__image-container--${type}`}>
            <div className="card__avatar-wrapper">
              <img
                className="card__avatar"
                src={imageSrc}
                alt=""
              />
            </div>
            <svg className="card__wave" viewBox="0 0 1440 120" xmlns="http://www.w3.org/2000/svg">
              <path d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"
                fill="#f8f9fa" fillOpacity="1">
              </path>
            </svg>
          </div>
        ) : imageSrc ? (
          <div className={`card__image-container card__image-container--${type}`}>
            <img
              className={`card__image card__image--${type}`}
              src={imageSrc}
              alt=""
            />
            <div className={`card__overlay card__overlay--${type}`}></div>
          </div>
        ) : null}

        <div className={`card__content card__content--${type}`}>
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default ModernCard;